import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdobeAnalyticsService } from 'src/app/adobe-analytics/services/adobe-analytics.service';
import { StartupService } from '../../common/services/startup.service';
import { applicationContentConfig } from '../../configs/config-internal-content';
import { BrandService } from '../../common/services/brand-service';
import { CommonUtilities } from '../../shared/util/common-utilities';
import { Subscription } from 'rxjs';
import { QuickLinkComponent } from 'ui-common-components-angular';
import { QuickLink } from '../../shared/models/ui-component-interfaces';
import { TealiumScriptService } from 'src/app/tealium-script/tealium-script.service';

@Component({
    selector: 'olb-app-useful-links',
    templateUrl: './useful-links.component.html',
    styleUrls: ['./useful-links.component.scss'],
    imports: [QuickLinkComponent]
})
export class UsefulLinksComponent implements OnInit, OnDestroy {
  quickLinks!: QuickLink[];
  public chatbotElementSubscription!: Subscription;

  constructor(
    private startup: StartupService,
    private adobeAnaylticsService: AdobeAnalyticsService,
    private readonly brandService: BrandService,
    private readonly tealiumService: TealiumScriptService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    if (this.brandService.isCahoot()) {
      this.quickLinks = this.getCahootQuickLinks();
    } else {
      this.quickLinks = this.getQuickLinks();
    }
  }

  // Quick link data retrieved from applicationContentConfig
  getQuickLinks(): QuickLink[] {
    return [
      applicationContentConfig.QUICK_LINK_ONE,
      applicationContentConfig.QUICK_LINK_TWO,
      applicationContentConfig.QUICK_LINK_THREE,
      applicationContentConfig.QUICK_LINK_FOUR,
      applicationContentConfig.QUICK_LINK_FIVE,
      applicationContentConfig.QUICK_LINK_SIX,
    ];
  }

  getCahootQuickLinks(): QuickLink[] {
    return [
      applicationContentConfig.CAHOOT_QUICK_LINK_ONE,
      applicationContentConfig.CAHOOT_QUICK_LINK_TWO,
      applicationContentConfig.CAHOOT_QUICK_LINK_THREE,
      applicationContentConfig.CAHOOT_QUICK_LINK_FOUR,
      applicationContentConfig.CAHOOT_QUICK_LINK_FIVE,
    ];
  }

  selectedQuickLink(link: string): void {
    if (link === 'lostStolenChat') {
      this.chatbotElementSubscription = this.adobeAnaylticsService.triggerEngagement(
        this.startup.lostAndStolenCards
      );
      this.tealiumService.trackEvent(this.startup.lostAndStolenCards);
    } else if (link === 'closeAccountChat') {
      this.chatbotElementSubscription = this.adobeAnaylticsService.triggerEngagement(
        this.startup.closeMyAccount
      );
      this.tealiumService.trackEvent(this.startup.closeMyAccount);
    } else {
      this.startup.navigateByUrl(this.startup.host + link);
    }
  }

  ngOnDestroy(): void {
    if(CommonUtilities.isNotNullEmptyAndUndefined(this.chatbotElementSubscription)){
      this.chatbotElementSubscription?.unsubscribe();
    }
  }

}
